export const getAuthState = (type) => (state) => state.status[type];
